import { enUS, zhTW } from 'date-fns/locale';
import { useTranslation } from 'next-i18next';

const useDateFnsLocale = () => {
  const { i18n } = useTranslation();

  const { language } = i18n;

  return language === 'zh-TW' ? zhTW : enUS;
};

export default useDateFnsLocale;
